export default __webpack_public_path__ + "0d1e16a0f7d075ae54a0227fd9e0fdb4.svg";